var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "hero-section mx-auto",
    style: _vm.styling
  }, [_c('div', {
    staticClass: "hero-content-wrapper flex lg:flex-nowrap xl:flex-nowrap justify-center lg:max-w-6xl mx-auto",
    class: [_vm.layout.mobile && [_vm.layout.mobile === 'flex-wrap' ? 'wrap-normal' : 'wrap-reverse'], _vm.layout.desktop && [_vm.layout.desktop === 'stacked' ? 'display-col' : _vm.layout.desktop === 'flex-row' ? 'row-normal' : 'row-reverse']]
  }, [_c('div', {
    staticClass: "hero-text-wrapper px-8 sm:pb-8 lg:pb-6 flex flex-col lg:justify-center xl:justify-center",
    class: [_vm.styles.textAlign, _vm.layout.desktop !== 'flex-row-reverse' ? 'xl:pl-24' : 'xl:pr-24']
  }, [_c('h1', {
    staticClass: "hero--header leading-none pt-6 mb-3 font-normal"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.content.heading) + "\n\t\t\t")]), _vm._v(" "), _vm.content.subheading ? _c('SanityBlockContent', {
    staticClass: "hero--subheading inline-block mb-3 text-lg font-light leading-relaxed",
    attrs: {
      "blocks": _vm.content.subheading
    }
  }) : _vm._e(), _vm._v(" "), _c('RoundButton', {
    attrs: {
      "text": _vm.content.cta.text,
      "url": _vm.content.cta.link,
      "color": _vm.content.cta.styles.color
    }
  }), _vm._v(" "), _vm.content.caption ? _c('SanityBlockContent', {
    staticClass: "mt-4 text-sm text-white",
    attrs: {
      "blocks": _vm.content.caption
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "hero-image-wrapper flex justify-center"
  }, [_c('SanityImage', {
    staticClass: "hero--image",
    attrs: {
      "asset-id": _vm.content.image && _vm.imageRef,
      "format": "auto"
    }
  })], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };